import { render, staticRenderFns } from "./VegaCheckout.vue?vue&type=template&id=2687c1a2&"
import script from "./VegaCheckout.vue?vue&type=script&lang=js&"
export * from "./VegaCheckout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports